export const stats = [
  { value: "12,800+", label: "累计征集线索", icon: "ri-inbox-archive-line" },
  { value: "3,600+", label: "已完成核实线索", icon: "ri-shield-check-line" },
  { value: "680 万", label: "累计发放悬赏金额", icon: "ri-hand-coin-line" },
  { value: "48 小时", label: "平均初步反馈时长", icon: "ri-timer-flash-line" },
];

export const processSteps = [
  {
    step: "01",
    title: "提交线索",
    desc: "通过征集入口填写时间、地点、涉及对象与关键材料，可选择匿名提交。",
    icon: "ri-send-plane-line",
  },
  {
    step: "02",
    title: "初步评估",
    desc: "核实团队在 48 小时内完成信息比对，判断线索价值与悬赏等级。",
    icon: "ri-search-eye-line",
  },
  {
    step: "03",
    title: "对接核实",
    desc: "以匿名编号与提供者沟通，补充材料、交叉验证，形成可追溯的记录。",
    icon: "ri-links-line",
  },
  {
    step: "04",
    title: "悬赏发放",
    desc: "线索经确认采纳后，按约定等级发放悬赏，并持续同步后续进展。",
    icon: "ri-award-line",
  },
];

export const values = [
  {
    title: "真实优先",
    desc: "所有进入核实流程的线索都要求有据可查，我们不传播未经证实的说法。",
    icon: "ri-fingerprint-line",
  },
  {
    title: "来源保护",
    desc: "对提供者信息进行脱敏与权限分级管理，把保护来源作为底线原则。",
    icon: "ri-lock-password-line",
  },
  {
    title: "公众价值",
    desc: "优先关注涉及公共利益、能够推动问题被看见与解决的议题。",
    icon: "ri-community-line",
  },
  {
    title: "理性克制",
    desc: "尊重事实边界，不针对个人，不渲染情绪，只把线索还原得更清楚。",
    icon: "ri-scales-3-line",
  },
];

export const testimonials = [
  {
    name: "林先生",
    role: "线索提供者",
    content:
      "提交后第二天就收到了初步反馈，全程用编号沟通，没有要求我公开身份，这一点让人很安心。",
  },
  {
    name: "周女士",
    role: "长期关注者",
    content:
      "分类做得很细，能看到不同类型线索的进展，悬赏等级说明也很清楚，不像一些平台只有噱头。",
  },
  {
    name: "陈同学",
    role: "社区志愿者",
    content:
      "我们把小区改造的问题整理后提交，补充材料的指引很具体，来回几次沟通效率比想象中高。",
  },
  {
    name: "吴先生",
    role: "行业从业者",
    content:
      "作为行业内的人，最看重的是对来源的保护。这里的流程说明写得明白，提交时不用顾虑太多。",
  },
];